import { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { message } from "antd";
import { useAuth } from "@/contexts";
import { ActionTypes } from "@/contexts/AuthContext/types";
import { GET_ADMIN_PROFILE } from "@/components/UserAuth/queries";
import { AdminProfile } from "@/types";

/**
 * Loads the logged in admin on every page load, so role changes apply without re-login.
 */
const useAdminProfile = () => {
	const {
		state: { token, user },
		dispatch,
	} = useAuth();
	const { data, error, refetch } = useQuery<{ getAdminProfile: AdminProfile }>(
		GET_ADMIN_PROFILE,
		{
			skip: !token,
			fetchPolicy: "network-only",
			notifyOnNetworkStatusChange: true,
		},
	);

	useEffect(() => {
		if (data) {
			dispatch({ type: ActionTypes.SET_USER, payload: data.getAdminProfile });
		}
	}, [data, dispatch]);

	useEffect(() => {
		// the API reports expired/invalid JWTs as statusCode 500, so logoutLink misses them
		if (error?.graphQLErrors.length) {
			message.warning("Your session has expired, please log in again");
			dispatch({ type: ActionTypes.LOGOUT });
		}
	}, [error, dispatch]);

	return { user, error, refetch };
};

export default useAdminProfile;
